interface ReleaseTopicStatuses {
  key: string;
  value: string;
}
export const ReleaseTopicStatusConst: ReleaseTopicStatuses[] = [
  {
    key: 'created',
    value: 'Created',
  },
  {
    key: 'freezed',
    value: 'Freezed',
  },
  {
    key: 'grooming',
    value: 'Grooming',
  },
  {
    key: 'dev_in_progress',
    value: 'Dev In-Progress',
  },
  {
    key: 'dev_completed',
    value: 'Dev Completed',
  },
  {
    key: 'breached',
    value: 'Breached',
  },
  {
    key: 'recalled',
    value: 'Recalled',
  },
  {
    key: 'completed',
    value: 'Completed',
  },
];
